import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=0ef5aa7c&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=0ef5aa7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5aa7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef5aa7c')) {
      api.createRecord('0ef5aa7c', component.options)
    } else {
      api.reload('0ef5aa7c', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=0ef5aa7c&scoped=true&", function () {
      api.rerender('0ef5aa7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u1eON4XuzoIb/JS/comp/Voucher.vue"
export default component.exports